/**
 * Avviso NON bloccante: il cliente ha bozze fattura aperte e i dati fiscali
 * dell'anagrafica sono appena cambiati (R6-B).
 *
 * Le bozze contengono snapshot che divergeranno dall'anagrafica aggiornata.
 * Non richiede conferma e non blocca nulla: è solo una segnalazione, che il
 * backend restituisce nel campo `avviso_bozze_aperte` della risposta al PATCH.
 */
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { FatturaRiferimento } from '../lib/modificaFiscale';

interface Props {
  bozze: FatturaRiferimento[];
  onDismiss: () => void;
}

export default function AvvisoBozzeAperte({ bozze, onDismiss }: Props) {
  const { t } = useTranslation();
  if (bozze.length === 0) return null;

  const numeri = bozze.map((b) => b.numero).filter(Boolean).join(', ');

  return (
    <div
      data-testid="avviso-bozze-aperte"
      className="flex items-start gap-2.5 px-4 py-3 rounded-lg border border-accent-info/30 bg-accent-info-bg text-sm text-ink-dark"
    >
      <Info size={16} className="text-accent-info flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p>{t('anagrafiche.modifica_fiscale.avviso_bozze', { count: bozze.length })}</p>
        {numeri && <p className="text-xs text-ink-soft mt-0.5 font-mono">{numeri}</p>}
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="text-xs text-ink-soft hover:text-ink-dark transition-colors flex-shrink-0"
      >
        {t('common.azioni.chiudi')}
      </button>
    </div>
  );
}
